module.exports = __webpack_public_path__ + "img/cuff elastic width.15179614.png";